import * as React from "react";
import classNames from "classnames";

import { Text } from "../";
import "./Sidebar.scss";

import { ChevronDownIcon, ChevronUpIcon } from "@tiendanube/icons";

export interface InterfaceSidebar {
  children: React.ReactNode;
  style: React.CSSProperties;
}

export interface InterfaceSidebarSection {
  children: React.ReactNode;
  title: string;
  open?: boolean;
  onClick?: () => void;
}

export interface InterfaceSidebarItem {
  active?: boolean;
  href: string;
  label: string;
}

function Sidebar({
  children,
  style,
}: InterfaceSidebar): JSX.Element {
  return (
    <div className="nimbus-web--sidebar" style={style}>
      {children}
    </div>
  );
}

export function SidebarSection({
  children,
  title,
  open= false,
  onClick,
}: InterfaceSidebarSection): JSX.Element {
  const sidebarSectionClass = classNames("nimbus-web--sidebar-section__content", {"open": open});

  return (
    <div className="nimbus-web--sidebar-section">
      <button onClick={onClick} type="button" className="nimbus-web--sidebar-section__title">
        <Text bold>{title}</Text>
        {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </button>
      <div className={sidebarSectionClass}>
        {children}
      </div>
    </div>
  );
}

export function SidebarItem({
  active= false,
  href,
  label,
}: InterfaceSidebarItem): JSX.Element {
  const sidebarItemClass = classNames("nimbus-web--sidebar-item", {"active": active});
  
  return (
    <a href={href} className={sidebarItemClass}>
      <Text>{label}</Text>
    </a>
  );
}

Sidebar.Section = SidebarSection;
Sidebar.Item = SidebarItem;

export default Sidebar;
